
export const PROMO_CODE_URL_PARAM = "promocode";
export const PROMO_REFERER_URL_PARAM = "promorefferer";
const PROMO_REFERER_URL_PARAMS = [PROMO_REFERER_URL_PARAM, "promoreferer"];

export function isPromoCodeUrlParam(key) {
  const lowerKey = (key || "").toLowerCase();
  return lowerKey === PROMO_CODE_URL_PARAM || PROMO_REFERER_URL_PARAMS.includes(lowerKey);
}

const PROMO_CODE_STORAGE_KEY = "promoCode";
const APPLIED_PROMO_CODE_STORAGE_KEY = "appliedPromoCode";

const readJson = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (e) {
    return null;
  }
};

const writeJson = (key, value) => {
  try {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(key);
    }
  } catch (e) {
  }
};

export function parsePromoCodeParam(value) {
  const rawValue = (value || "").trim();
  const separatorIndex = rawValue.indexOf("-");
  if (separatorIndex === -1) {
    return { promocode: rawValue, promoreferer: "" };
  }
  return {
    promocode: rawValue.slice(0, separatorIndex).trim(),
    promoreferer: rawValue.slice(separatorIndex + 1).trim()
  };
}


export function getPromoCodeFromSearch(search = window.location.search) {
  const searchParams = new URLSearchParams(search);
  let promoCodeParam = "";
  let promoRefererParam = "";
  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === PROMO_CODE_URL_PARAM) {
      promoCodeParam = value;
    } else if (PROMO_REFERER_URL_PARAMS.includes(key.toLowerCase()) && !promoRefererParam) {
      promoRefererParam = value;
    }
  }
  const parsed = parsePromoCodeParam(promoCodeParam);
  return {
    promocode: parsed.promocode,
    promoreferer: parsed.promocode ? parsed.promoreferer || promoRefererParam.trim() : ""
  };
}

export function savePromoCode(promo) {
  const promocode = (promo?.promocode || "").trim();
  writeJson(PROMO_CODE_STORAGE_KEY, promocode ? { promocode, promoreferer: (promo?.promoreferer || "").trim() } : null);
}

export function getStoredPromoCode() {
  const stored = readJson(PROMO_CODE_STORAGE_KEY);
  return {
    promocode: stored?.promocode || "",
    promoreferer: stored?.promoreferer || ""
  };
}


export function getInitialPromoCode() {
  const fromUrl = getPromoCodeFromSearch();
  const stored = getStoredPromoCode();
  if (fromUrl.promocode) {
    const promo = {
      promocode: fromUrl.promocode,
      promoreferer: fromUrl.promoreferer || (stored.promocode === fromUrl.promocode ? stored.promoreferer : "")
    };
    savePromoCode(promo);
    return promo;
  }
  return stored;
}

export function saveAppliedPromoCode(auctionId, promo) {
  if (!promo || !promo.promocode) {
    const current = readJson(APPLIED_PROMO_CODE_STORAGE_KEY);
    if (!current || String(current.auctionId) === String(auctionId)) {
      writeJson(APPLIED_PROMO_CODE_STORAGE_KEY, null);
    }
    return;
  }
  writeJson(APPLIED_PROMO_CODE_STORAGE_KEY, {
    auctionId: String(auctionId),
    promocode: promo.promocode,
    promoreferer: promo.promoreferer || ""
  });
}

export function getPromoCodeContactFormPayload(auctionId) {
  const applied = readJson(APPLIED_PROMO_CODE_STORAGE_KEY);
  if (!applied || !applied.promocode || auctionId == null || String(applied.auctionId) !== String(auctionId)) {
    return {};
  }
  return {
    PromoCode: applied.promocode,
    ...(applied.promoreferer ? { ReffererId: applied.promoreferer } : {})
  };
}

export function setPromoCodeInUrl(url, promo) {
  if (!url) {
    return url;
  }
  const hashIndex = url.indexOf("#");
  const hash = hashIndex === -1 ? "" : url.slice(hashIndex);
  const withoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const queryIndex = withoutHash.indexOf("?");
  const path = queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
  const searchParams = new URLSearchParams(queryIndex === -1 ? "" : withoutHash.slice(queryIndex + 1));

  Array.from(searchParams.keys())
    .filter(isPromoCodeUrlParam)
    .forEach((key) => searchParams.delete(key));

  const promocode = (promo?.promocode || "").trim();
  const promoreferer = (promo?.promoreferer || "").trim();
  if (promocode) {
    searchParams.set(PROMO_CODE_URL_PARAM, promocode);
    if (promoreferer) {
      searchParams.set(PROMO_REFERER_URL_PARAM, promoreferer);
    }
  }

  const query = searchParams.toString();
  return `${path}${query ? `?${query}` : ""}${hash}`;
}

export function replacePromoCodeInCurrentUrl(promo) {
  try {
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const nextUrl = setPromoCodeInUrl(currentUrl, promo);
    if (nextUrl !== currentUrl) {
      window.history.replaceState(window.history.state, "", nextUrl);
    }
  } catch (e) {
  }
}

export function getPromoCodeForVehicleDetails(search = window.location.search) {
  const fromPromoCode = getPromoCodeFromSearch(search);
  if (fromPromoCode.promocode) {
    return fromPromoCode;
  }
  const promotionsParam = new URLSearchParams(search).get("promotions") || "";
  const firstPromotion = promotionsParam.split(",").map((code) => code.trim()).find(Boolean) || "";
  return { promocode: firstPromotion, promoreferer: "" };
}
